import React, { useState, useContext } from 'react';
import { Box, Typography } from '@mui/material';
import {
  DataAccessContextType,
  DataAccessContext,
} from '@matematykagryzie/data-access';

import { SubmittedEmail } from './submitted-email';
import { GetEmail } from './get-email';

export function Register() {
  const [isSubmited, setIsSubmited] = useState<boolean>(false);
  const { addEmail, downloadFileFromStorage } =
    useContext<DataAccessContextType>(DataAccessContext);
  const fileName = 'tablice-maturalne-z-matematyki.pdf';

  const onValidatedSumbit = (email: string): void => {
    addEmail(email, 'webinar_signup');
    downloadFileFromStorage(fileName, fileName, 'downloaded-tables');
  };

  if (isSubmited) {
    return <SubmittedEmail />;
  }

  return (
    <Box>
      <Typography align="center" variant="body1">
        Zapisz się na darmowe grupowe korepetycje online przygotowujące do
        matury z matematyki podstawowej.
      </Typography>

      <GetEmail
        onValidatedSumbit={onValidatedSumbit}
        setIsSubmited={setIsSubmited}
        isSubmited={isSubmited}
        buttonLabel="Zapisuje się"
      />
      <Typography align="center" variant="body2">
        Podaj email a otrzymasz wzory, których nie znajdziesz w tablicach
        matematycznych.
      </Typography>
    </Box>
  );
}

export default Register;
